import Image from 'next/image';
import { useEffect, useRef } from 'react';

import { PAST_CAR_COVER_HEIGHT, PAST_CAR_COVER_WIDTH } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Item: Component = (props) => {
  const {
    make,
    model,
    launchedYear,
    endedYear,
    thumbnailUrl,
  } = props;
  const containerRootElRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const { current: containerRootEl } = containerRootElRef;

    if (!containerRootEl) {
      return undefined;
    }

    const observer = new ResizeObserver(() => {
      const { requestAnimationFrame, cancelAnimationFrame } = window;

      const reqAnimId = requestAnimationFrame(() => {
        cancelAnimationFrame(reqAnimId);
      });
    });

    observer.observe(containerRootEl);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={containerRootElRef}
      className={styles.containerRoot}>
      <figure
        className={styles.containerPastCarCover}>
        <Image
          alt="past car image"
          className={styles.imagePastCarCover}
          height={PAST_CAR_COVER_HEIGHT}
          src={thumbnailUrl}
          width={PAST_CAR_COVER_WIDTH} />
      </figure>
      <div className={styles.containerYears}>
        (
        {launchedYear}
        -
        {endedYear}
        )
      </div>
      <div className={styles.containerCarDetail}>
        {make}
        {' '}
        {model}
      </div>
    </div>
  );
};
